import { createActionCreator } from "common/ReduxUtils";
import { StorageCargoPalletDetailsActionTypes } from "./StorageCargoPalletDetailsActionTypes";

export const setIsCalculateRateDisabled = createActionCreator<boolean>(
  StorageCargoPalletDetailsActionTypes.SET_IS_CALCULATE_RATE_DISABLED,
  "isCalculateRateDisabled"
);
